import { render, staticRenderFns } from "./AdminCashier.vue?vue&type=template&id=1332c7b4&scoped=true"
import script from "./AdminCashier.vue?vue&type=script&lang=js"
export * from "./AdminCashier.vue?vue&type=script&lang=js"
import style0 from "./AdminCashier.vue?vue&type=style&index=0&id=1332c7b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1332c7b4",
  null
  
)

export default component.exports